import React from 'react';
import { motion } from 'framer-motion';
import ChessSquare from './ChessSquare';

const ChessBoard = ({ board, selectedSquare, validMoves, onSquareClick, currentPlayer }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="inline-block p-4 bg-gradient-to-br from-amber-100 to-amber-200 rounded-2xl shadow-2xl border-4 border-amber-800"
    >
      <div className="grid grid-cols-8 gap-0 bg-amber-900 p-2 rounded-xl">
        {board.map((row, rowIndex) =>
          row.map((piece, colIndex) => {
            const isSelected = selectedSquare && selectedSquare[0] === rowIndex && selectedSquare[1] === colIndex;
            const isValidMove = validMoves.some(move => move.row === rowIndex && move.col === colIndex);
            const isLight = (rowIndex + colIndex) % 2 === 0;
            
            return (
              <ChessSquare
                key={`${rowIndex}-${colIndex}`}
                piece={piece}
                isLight={isLight}
                isSelected={isSelected}
                isValidMove={isValidMove}
                onClick={() => onSquareClick(rowIndex, colIndex)}
                row={rowIndex}
                col={colIndex}
              />
            );
          })
        )}
      </div>
      
      {/* Board coordinates */}
      <div className="flex justify-between px-6 mt-2">
        {['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'].map(letter => (
          <span key={letter} className="text-amber-800 font-semibold text-sm">
            {letter}
          </span>
        ))}
      </div>
    </motion.div>
  );
};

export default ChessBoard;